import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; //npm install @ng-bootstrap/ng-bootstrap@5.3.0
import { NgImageSliderModule } from 'ng-image-slider'; //npm i ng-image-slider@2.5.0 ---- Only for static
import { NgxSlickJsModule } from 'ngx-slickjs';// https://stackblitz.com/edit/ngx-slickjs?file=src%2Fapp%2Fapp.component.html  https://www.npmjs.com/package/ngx-slickjs
@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    NgbModule,
    NgImageSliderModule,
    NgxSlickJsModule.forRoot({
      links: {
        jquery: "https://code.jquery.com/jquery-3.4.0.min.js",
        slickJs: "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js",
        slickCss: "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css",
        slickThemeCss: "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css"
      }
    })
  ]
})
export class DashboardModule { }
